import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const FREQUENCIES = [
    80,
    120,
    220,
    380,
    550,
    750,
    1000,
    1200,
    1400,
    1800,
    2000,
    2400,
    3000,
    4000,
    5000,
    6000,
    7000,
    8000,
    10000,
    14000,
    18000
];

const GAINS = [0.25, 0.5, 1, 1.5, 2, 2.5, 3, 3,5];
const FormantsHelper = ({width, height}) => { 
    let fn = (frequency) => Math.sqrt(frequency / 20000) * width;
    let fn2 = (gain) => {
        let y = height - (gain / 4.0) * height;
        if (height === 300) {
            y -= (10 * (width / 200));
            y -= 40;
        }
        return y;
    };
    return (<svg className="formants-helper" width={width} height={height}>
            {GAINS.map(
                gain=> <line
                         className="gain-helper"
                          y1={fn2(gain)}
                          x1={0}
                          y2={fn2(gain)}
                          x2={width}
                        />)}
            {FREQUENCIES.map(
                freq => <line
                          x1={fn(freq)}
                          y1={0}
                          x2={fn(freq)}
                          y2={height}
                        />)}
            </svg>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantsHelper);
